const updateButtons = (swiper) => {
    if (!swiper.navigation ||
        !swiper.navigation.prevEl ||
        !swiper.navigation.prevEl)
        return;
    const params = swiper.params.navigation;
    const prevButton = swiper.navigation.prevEl;
    const nextButton = swiper.navigation.nextEl;
    if (swiper.navigation.prevEl.classList.contains(params.disabledClass) &&
        swiper.navigation.nextEl.classList.contains(params.disabledClass)) {
        prevButton.classList.add('hide-nav');
        nextButton.classList.add('hide-nav');
    }
    else {
        prevButton.classList.remove('hide-nav');
        nextButton.classList.remove('hide-nav');
    }
    if (swiper.navigation.prevEl.classList.contains(params.disabledClass)) {
        prevButton.setAttribute('disabled', '');
    }
    else {
        prevButton.removeAttribute('disabled');
    }
    if (swiper.navigation.nextEl.classList.contains(params.disabledClass)) {
        nextButton.setAttribute('disabled', '');
    }
    else {
        nextButton.removeAttribute('disabled');
    }
};

export { updateButtons };
